import { Popover } from "@mui/material";
import { update } from "ramda";
import React, { useRef, useState } from "react";

const zIndex = 10;

export function MouseHoverPopover({ children, renderAnchorEl }) {
  const anchorRef = useRef();
  const [mouseOvers, setMouseOvers] = useState([false, false]);
  const setMouseOver = ({ index, value, delayed }) => {
    const updateState = () => setMouseOvers(update(index, value));
    if (delayed) {
      setTimeout(() => updateState(), 100);
    } else updateState();
  };
  const open = mouseOvers.some(Boolean);

  const getHandlers = (index) => {
    return {
      onMouseEnter: () =>
        setMouseOver({
          index,
          value: true,
          delayed: false,
        }),
      onMouseLeave: () =>
        setMouseOver({
          index,
          value: false,
          delayed: true,
        }),
    };
  };

  return (
    <div>
      {renderAnchorEl({
        "aria-owns": open ? "mouse-over-popover" : undefined,
        "aria-haspopup": "true",
        ref: anchorRef,
        ...getHandlers(0),
      })}
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        // onClose={handlePopoverClose}
        disableRestoreFocus
        slotProps={{
          root: {
            sx: { zIndex: 10 },
          },
          paper: getHandlers(1),
          backdrop: {
            sx: {
              // background: "pink",
              pointerEvents: "none", // not working
            },
          },
        }}
      >
        {children}
      </Popover>
    </div>
  );
}

MouseHoverPopover.zIndex = zIndex;
